import { Link } from "react-router-dom";
import { ROUTES } from "../../../../app/config/routes";
import { useTheme } from "../../../../app/providers/ThemeProvider";
import logoDark from "../../../../assets/images/Tencotics,logo-02.png";
import logoLight from "../../../../assets/images/Tencotics,logo-04.png";
import {
  RiWhatsappLine,
  RiInstagramLine,
  RiLinkedinBoxLine,
  RiMapPinLine,
} from "react-icons/ri";

const Footer = () => {
  const { theme } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer className="app-chrome tec-landing-footer">
      <div className="tec-landing-footer__container">
        <div className="tec-landing-footer__main tec-landing-footer__main--columns">
          <div className="tec-landing-footer__brand-col">
            <Link to={ROUTES.HOME} className="tec-landing-footer__brand" aria-label="Tecnotics">
              <img
                src={theme === "dark" ? logoDark : logoLight}
                alt="Tecnotics"
                className="tec-landing-footer__brand-logo"
              />
            </Link>
          </div>

          <div className="tec-landing-footer__col">
            <h3 className="tec-landing-footer__col-title">Información institucional</h3>
            <ul className="tec-landing-footer__list">
              <li>
                <Link to={ROUTES.QUIENES_SOMOS} className="tec-landing-footer__list-link">
                  ¿Quiénes somos?
                </Link>
              </li>
              <li>
                <Link to={ROUTES.POLITICAS_PRIVACIDAD} className="tec-landing-footer__list-link">
                  Política de privacidad y tratamiento de datos
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CONTACTO} className="tec-landing-footer__list-link">
                  Trabaja con nosotros
                </Link>
              </li>
              <li>
                <a
                  href={ROUTES.LOGIN_EXTERNO}
                  className="tec-landing-footer__list-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Iniciar sesión
                </a>
              </li>
            </ul>
          </div>

          <div className="tec-landing-footer__col tec-landing-footer__col--social">
            <h3 className="tec-landing-footer__col-title">Síguenos</h3>
            <div className="tec-landing-footer__social">
              <a
                href="https://wa.me/573185078721"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="tec-landing-footer__social-link"
              >
                <RiWhatsappLine />
              </a>
              <a
                href="https://www.instagram.com/tecnotics_sas"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="tec-landing-footer__social-link"
              >
                <RiInstagramLine />
              </a>
              <a
                href="https://www.linkedin.com/company/tecnotics"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="tec-landing-footer__social-link"
              >
                <RiLinkedinBoxLine />
              </a>
            </div>
          </div>

          <div className="tec-landing-footer__col">
            <h3 className="tec-landing-footer__col-title">Contáctanos</h3>
            <ul className="tec-landing-footer__list">
              <li className="tec-landing-footer__contact-item">
                <RiMapPinLine className="tec-landing-footer__contact-icon" />
                <span>Terminal del Sur, Medellín, Colombia</span>
              </li>
              <li>
                <b>Teléfono:</b> +57 318 5078721
              </li>
              <li>
                <b>Correo:</b>{" "}
                <a href="mailto:info@tecnotics.com" className="tec-landing-footer__list-link">
                  info@tecnotics.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="tec-landing-footer__divider" />

        <div className="tec-landing-footer__bottom tec-landing-footer__bottom--centered">
          <p className="tec-landing-footer__copy">
            &copy; {year} Tecnotics. Todos los derechos reservados.{" "}
            <Link to={ROUTES.POLITICAS_PRIVACIDAD} className="tec-landing-footer__legal-link">
              Políticas y Privacidad
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
